import { render } from "./DetalharTaxaPagamento.vue?vue&type=template&id=53a56f2e&scoped=true"
import script from "./DetalharTaxaPagamento.vue?vue&type=script&lang=js"
export * from "./DetalharTaxaPagamento.vue?vue&type=script&lang=js"

import "./DetalharTaxaPagamento.vue?vue&type=style&index=0&id=53a56f2e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a56f2e"]])

export default __exports__